import { ChangeDetectionStrategy, Component, OnInit, Input, SimpleChanges, OnChanges, ChangeDetectorRef } from '@angular/core';

import { HighchartsChartModule } from 'highcharts-angular';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';
import HC_exportData from 'highcharts/modules/export-data';
import { Chart } from 'highcharts';

let modulesInitialized = false;

@Component({
    imports: [HighchartsChartModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-piechart-shared',
    templateUrl: './piechart.component.html',
    styleUrls: ['./piechart.component.css']
})
export class PiechartSharedComponent implements OnInit, OnChanges {

  Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  @Input() data: any;
  updateFlag = false;
  initialized = false;

  constructor(private cdr: ChangeDetectorRef) {
    // Initialize Highcharts modules only once
    if (!modulesInitialized) {
      HC_exporting(Highcharts);
      HC_exportData(Highcharts);
      modulesInitialized = true;
    }
  }

  ngOnInit(): void {
    this.chartOptions = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        events: {
          load() {
            // Calculate and add 'Unselected' slice dynamically
            const sum = this.series[0].data
              .reduce((acc: number, p: any) => acc + p.y, 0);
            this.series[0].addPoint({
              name: 'Unselected',
              y: 100 - sum,
              color: 'transparent'
            });
          }
        }
      },
      title: {
        text: ''
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      accessibility: {
        point: {
          valueSuffix: '%'
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
          }
        }
      },
      exporting: {
        enabled: true
      },
      credits: {
        enabled: false
      },
      series: [{
        name: 'BFSI',
        colorByPoint: true,
        data: this.data
      }] as Highcharts.SeriesOptionsType[]
    };

    this.initialized = true;

    // Trigger window resize to render chart properly in some cases
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateFlag = false;
    if (changes.data && this.initialized) {
      // Update chart series data dynamically
      (this.chartOptions.series as any)[0].data = this.data;
      this.updateFlag = true;
      this.cdr.markForCheck();
      this.cdr.detectChanges();
    }
  }
}
